"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserListItem = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var UserListItem = function UserListItem(_ref) {
  var user = _ref.user,
      _onClick = _ref.onClick,
      customIcon = _ref.customIcon;
  return (0, _preact.h)("div", {
    className: "list-item",
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      return _onClick(user);
    }
  }, !customIcon && (0, _preact.h)(_UserAvatar.default, {
    disableLink: true,
    disablePopup: true,
    user: user
  }), customIcon && (0, _preact.h)("span", {
    className: "list-item-custom-icon"
  }, customIcon), (0, _preact.h)("div", null, user.name));
};

exports.UserListItem = UserListItem;

var UserList = function UserList(_ref2) {
  var users = _ref2.users,
      onClick = _ref2.onClick;
  return (0, _preact.h)("div", {
    className: "list"
  }, users.map(function (user) {
    return (0, _preact.h)(UserListItem, {
      key: user.id,
      user: user,
      onClick: onClick
    });
  }));
};

var _default = UserList;
exports.default = _default;